var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryV2Inline = function SvgDeliveryV2Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.252 8.091-6.397-3.7M16.503 12.857v-5.78a1.45 1.45 0 0 0-.723-1.25l-5.058-2.891a1.45 1.45 0 0 0-1.445 0l-5.058 2.89a1.45 1.45 0 0 0-.723 1.25v5.781a1.45 1.45 0 0 0 .723 1.25l5.058 2.89a1.45 1.45 0 0 0 1.445 0l5.058-2.89a1.45 1.45 0 0 0 .723-1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.183 6.4 10 9.977 3.8 6.39M10 17v-7"
  })));
};
export default SvgDeliveryV2Inline;